import { connectHook } from 'app/common/components/connect-hook';
import { Confirm } from './confirm.js';
import { useConfirm } from './confirm-hook.js';

export default connectHook(Confirm, useConfirm);
